export const UPDATE_TOAST_DURATION_SECONDS = 30;
